module.exports = __webpack_public_path__ + "static/mychoize_logo-c3ccd3fc974f4accbad0500faf8da749.png";